import { SET_MODULE } from './mutation-types';

const mutations = {
    [SET_MODULE](state, module) {
        delete module.settings;
        state.data.module = module;
    },
};

export default mutations;